import React from "react";

const Dialog = ({ header, children, setState, needClose = true }) => {
  return (
    <div className="absolute top-0 left-0 flex h-screen w-full items-center justify-center">
      <div
        className="fixed top-0 z-[40] h-full"
        onClick={() => {
          if (needClose) {
            setState(false);
          }
        }}
      >
        <div className="h-screen w-screen bg-black opacity-25"></div>
      </div>
      <div
        className={`showing fixed z-[100] max-h-full min-h-[160px] w-[95%] min-w-[300px] max-w-full rounded-md bg-white p-4 lg:w-3/5`}
      >
        <div className="flex w-full items-center justify-between border-b py-2">
          <p className="font-sans text-base font-medium">{header}</p>

          <img
            src={"/icon/close.svg"}
            alt="icon-close"
            className="h-4 w-4 cursor-pointer invert"
            onClick={() => setState(false)}
          />
        </div>
        {children}
      </div>
      <style>
        {`
          @keyframes show {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          .showing {
            animation-name: show;
            animation-duration: 0.5s;
            animation-timing-function: ease-in-out;
            animation-fill-mode: backwards;
          }
        `}
      </style>
    </div>
  );
};

export default Dialog;
